export default __webpack_public_path__ + "static/media/nesto-online-app5.f11e4554.png";